import { withStyles } from "@material-ui/core";
import Tooltip from "../../../../common/StyledToolTip";

// override tooltip styles to support gantt lib styling.
const styles = () => ({
    tooltip: {
      backgroundColor: "#EFEFEE",
      color: "#3E3E3E",
    },
  });
  
 export default withStyles(styles)(Tooltip); 